import CautionCircleOutlined from 'msb-icons-svg/lib/src/icons/CautionCircleOutlined';
import PlusCircleOutlined from 'msb-icons-svg/lib/src/icons/PlusCircleOutlined';
import React from 'react';
import Button from '../button';
import { Col, Row } from '../grid';
import Space from '../space';
import Typography from '../typography';
import Upload from './Upload';
const UploadCard = (props, ref) => (React.createElement(Row, { justify: "space-between", align: "middle" },
    React.createElement(Col, null,
        React.createElement("div", null, "Document name"),
        React.createElement("div", null,
            React.createElement(Typography.Note, { level: 2, disabled: true }, "\u1EA2nh, Word, PDF"))),
    React.createElement(Col, null,
        React.createElement(Space, null,
            React.createElement(CautionCircleOutlined, null),
            React.createElement(Upload, Object.assign({}, props, { ref: ref }),
                React.createElement(Button, { icon: React.createElement(PlusCircleOutlined, null) }, "T\u1EA3i h\u1ED3 s\u01A1 l\u00EAn"))))));
export default React.forwardRef(UploadCard);
